import ApiGetOptions from '@/datatypes/api-get-options';
import ApiService from '@/services/api/ApiService';

export default class PromocodeCampaignService extends ApiService {
  public list(options) {
    return this.call(new ApiGetOptions(
      {
        url: '/promocode_campaigns',
        params: options,
      },
    ));
  }

  public retrieve(campaignId) {
    return this.call(new ApiGetOptions(
      {
        url: `/promocode_campaigns/${campaignId}`,
      },
    ));
  }

  public listRedeemedCodes(campaignId, options) {
    return this.call(new ApiGetOptions(
      {
        url: `/promocode_campaigns/${campaignId}/promocodes/redeemed`,
        params: options,
      },
    ));
  }

  public downloadCsv(campaignId) {
    return this.call(new ApiGetOptions(
      {
        url: `/promocode_campaigns/${campaignId}/promocodes/redeemed/csv`,
      },
    ));
  }

  public downloadUrlCsv(campaignId) {
    return this.call(new ApiGetOptions(
      {
        url: `/promocode_campaigns/${campaignId}/promocodes/urls`,
      },
    ));
  }
}
